import { themeObject } from '../../../../../lib';

export interface HistoryComponentProps {
    handleBackButtonClick: () => void;
    handleApplyButtonClick: (query: string) => void;
}

export interface HistoryQueriesType {
    query: string;
    timestamp: string;
    isExpanded: boolean;
}

export const historyComponentStyles = {
    mainContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        p: '8px 14px 8px 8px',
        height: '100%',
    },
    labelAndButtonContainerStyles: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        pb: 1,
    },
    accordionContainerStyles: {
        overflowY: 'auto',
        pr: '4px',
        overflowX: 'hidden',
    },
    widthStyles: {
        width: '100%',
    },
    accordionDetailsStyles: {
        p: '0px 16px 12px 16px',
    },
    accordionDetailsContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '10px',
    },
    contentContainerStyles: {
        border: `1px solid ${themeObject.palette.grayScale[500]}`,
        p: '12px 24px 18px 12px',
        borderRadius: '4px',
        maxHeight: '110px',
        overflowY: 'auto',
    },
    buttonContainerStyles: {
        display: 'flex',
        justifyContent: 'end',
    },
    buttonStyles: {
        width: '125px',
        height: '30px',
        fontSize: '14px',
    },
    customImageStyles: {
        height: '86.97px',
        width: '153.26px',
    },
    customHeadingTextStyles: {
        fontFamily: 'Raleway',
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '100%',
        color: themeObject.palette.primary[700],
    },
    customHeadingContainerStyles: {
        my: '12px',
    },
    queryTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '100%',
        color: themeObject.palette.grayScale[700],
    },
};
